import { Button } from 'react-bootstrap';
import { ReactComponent as ImageCaretRight } from '../../images/caret-right-fill.svg';
import { settings } from '../../config/settings';
import React from 'react';


const SubNavigationTeaserButton = () => {

    return (
        <React.Fragment>
            <div className="d-block d-lg-none" style={{ backgroundColor: '#fc790d', color: '#fff', width: '100%', textAlign: 'center', padding: '5px 0' }}>
                {settings.nextTextLong} <strong>{settings.nextTermin}</strong>
            </div>
            <div className="d-none d-lg-block">
                <Button
                    href="/Anmeldung"
                    variant="rbs-button-orange info-teaser"
                    size="lg"
                >
                    <ImageCaretRight
                        className="me-1 SubNavigationTeaserButton"
                        width={16}
                        height={16}
                        fill='#fff'
                    />
                    {settings.nextTextShort} <strong>{settings.nextTermin}</strong>
                </Button>
            </div>
        </React.Fragment>
    )

};

export default SubNavigationTeaserButton;
